module.exports = require("whatwg-fetch");


//////////////////
// WEBPACK FOOTER
// external "whatwg-fetch"
// module id = 35
// module chunks = 0